'use client';

import { ReactNode } from 'react';

export type UseClientProps = {
  children: ReactNode | ReactNode[];
};

const UseClient = ({ children }: UseClientProps) => <>{children}</>;
export default UseClient;
